module.exports = __webpack_public_path__ + "img/ghs-03--1.5dfccb40.png";